import { PATHS } from '@/infrastructure/utils/route-constants';

export default function authorized({ next, router, store, to }) {
  if (store.getters['login/isAuthenticated']) {
    const accessOptionsByProfile =
      store.getters['login/accessOptionsByProfile'];
    const isAuthorized = accessOptionsByProfile.some((option) => {
      if (
        option.path.replace(/^\/|\/$/g, '') === to.path.replace(/^\/|\/$/g, '')
      ) {
        return true;
      } else {
        if (to.path.includes(option.path)) {
          return option.children.some(
            (pathChildren) =>
              pathChildren.path.replace(/^\/|\/$/g, '') ===
              to.path.replace(/^\/|\/$/g, '')
          );
        } else {
          return false;
        }
      }
    });
    if (!isAuthorized) {
      return router.push(PATHS.errors.deny);
    }
    return next();
  } else {
    return next();
  }
}
